import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Leaf, Truck, Award, Heart, Mountain } from "lucide-react";
import { STORE } from "@/config";

const KASHMIR = "https://images.unsplash.com/photo-1621232082074-1a7750ecc557?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export default function About() {
  return (
    <div>
      <section className="relative">
        <img src={KASHMIR} alt="Kashmir" className="h-64 sm:h-80 w-full object-cover" />
        <div className="absolute inset-0 hero-overlay grid place-items-center text-center px-4">
          <div>
            <p className="text-xs uppercase tracking-widest text-[#FDE68A] font-semibold">Our Story</p>
            <h1 className="font-display text-4xl sm:text-5xl font-bold text-white mt-2">About Sonia Dry Fruits</h1>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-4xl px-4 sm:px-6 py-14">
        <p className="text-lg text-[#1F130B] leading-relaxed font-display">
          From the snow-fed valleys of Kashmir to your doorstep — a legacy of purity, freshness and trust.
        </p>
        <p className="mt-5 text-[#6B5B52] leading-relaxed">
          Sonia Dry Fruits Jammu began with a simple belief: that everyone deserves access to the finest, most authentic dry fruits that Kashmir has to offer. For over 25 years, our family has been sourcing walnuts, almonds, saffron and pine nuts directly from trusted growers across Kashmir and the Himalayas.
        </p>
        <p className="mt-4 text-[#6B5B52] leading-relaxed">
          Every product is hand-selected, quality-checked, and hygienically packed to preserve its natural taste and nutrition. We ship fresh across India, bringing the authentic flavours of Kashmir to homes nationwide — with complete transparency and care.
        </p>

        <div className="mt-10 grid sm:grid-cols-3 gap-5">
          {[
            [Mountain, "Directly Sourced", "Straight from Kashmiri orchards & Himalayan farms"],
            [Leaf, "Always Fresh", "Hygienically packed in small batches"],
            [ShieldCheck, "100% Authentic", "No adulteration, no compromise on quality"],
            [Award, "Premium Grade", "Only hand-graded, top-tier produce"],
            [Truck, "Pan-India Delivery", "Fast, tracked shipping everywhere"],
            [Heart, "Loved by 5000+", "A growing family of happy customers"],
          ].map(([Icon, t, d]) => (
            <div key={t} className="rounded-2xl bg-white border border-[#E7E0D6] p-6">
              <Icon size={24} className="text-[#C2410C]" />
              <h3 className="font-display text-lg font-semibold text-[#1F130B] mt-3">{t}</h3>
              <p className="text-sm text-[#6B5B52] mt-1.5 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-3xl dark-luxury p-8 sm:p-12 text-center">
          <h2 className="font-display text-2xl sm:text-3xl font-bold text-white">Taste the authentic Kashmir today</h2>
          <p className="mt-3 text-[#B9A794]">Explore our premium collection of dry fruits, nuts and saffron.</p>
          <Link to="/shop" className="inline-flex mt-6 rounded-full bg-[#C2410C] hover:bg-[#9A3412] text-white font-semibold px-8 py-3.5 transition-colors">Shop Now</Link>
        </div>
      </section>
    </div>
  );
}
